module.exports = __webpack_public_path__ + "static/img/zjgn02.07d7197.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/zjgn02.jpg
// module id = 1425
// module chunks = 0